module.exports = __webpack_public_path__ + "96427a1214f787c3fab7dc241cc95840.png";